import { useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useState, FormEvent } from 'react'
import { recuperarSenha, novaSenha, buscarProjetos } from '../../services/auth'
import { Button, Loader } from '../Styles'
import './recuperarsenha.css'
import { toast } from 'react-toastify'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { projetosUsuario } from '../../interfaces/auth'
import ModalProjetosUsuario from '../ModalProjetosUsuario'

function ModalRecuperarSenha() {
    const { modalExibir, modal } = useContext(ModalEstadoContext)
    const navigate = useNavigate()
    const { pathname, search } = useLocation()

    const paramsUrl = new URLSearchParams(search)
    const idOrganizacaoProjetoSelecionada = paramsUrl.get('o-s')

    const [email, setEmail] = useState('')
    const [token, setToken] = useState('')
    const [senha, setSenha] = useState('')
    const [idOrganizacaoProjeto, setIdOrganizacaoProjeto] = useState<string | null>(null)
    const [confirmarSenha, setConfirmarSenha] = useState('')
    const [formToken, setFormToken] = useState(false)
    const [formSenha, setFormSenha] = useState(false)
    const [processando, setProcessando] = useState(false)
    const [projetosUsuario, setProjetosUsuario] = useState<projetosUsuario[]>([])

    function ocultarModal() {
        navigate('/')
        return modalExibir("")
    }

    const proximoPasso = async (e: FormEvent) => {
        e.preventDefault()

        setProcessando(true)

        try {
            if (!idOrganizacaoProjeto) {
                return setProcessando(false)
            }

            const payload = {
                email,
                idOrganizacao: idOrganizacaoProjeto
            }

            const resposta = await recuperarSenha(payload)

            if (resposta.status === 200) {
                setProcessando(false)
                return setFormToken(true)
            }

        } catch (error: any) {

            if (error.response.status === 400) {
                setProcessando(false)
                toast.error("Usuario não encontrado.")
                modalExibir("")
            }

            return alert(error)

        }
    }

    const buscarProjetosUser = async (e: FormEvent) => {

        e.preventDefault()
        setProcessando(true)
        try {

            const payload = {
                email
            }

            const resposta = await buscarProjetos(payload)

            if (resposta.data.length === 0) {
                return toast.error("Usuario não possui projetos vinculados.")
            }
            if (resposta.data.length === 1) {

                navigate(`${pathname}?o-s=${resposta.data[0].idOrganizacao}`)

                setFormToken(true)

                const payload = {
                    email,
                    idOrganizacao: resposta.data[0].idOrganizacao
                }

                await recuperarSenha(payload)

                return setProcessando(false)
            }

            setFormToken(true)

            setProjetosUsuario(resposta.data)
            modalExibir('ModalProjetosUsuarioRecuperarSenha')

            navigate(`${pathname}#${email}`)

            return setProcessando(false)

        } catch (error: any) {

            if (error.response.status === 404) {
                setProcessando(false)
                toast.error("Usuario Não encontrado.")
            }
        }
    }

    const digitarSenha = async (e: FormEvent) => {
        e.preventDefault()

        setFormToken(false)
        return setFormSenha(true)
    }

    const cadastrarNovaSenha = async (e: FormEvent) => {
        e.preventDefault()

        setProcessando(true)

        if (senha !== confirmarSenha) {
            return toast.warn('A senha não confere. Digite Novamente')
        }

        try {
            if (!idOrganizacaoProjeto) {
                return setProcessando(false)
            }

            const payload = {
                email,
                senha,
                token,
                idOrganizacao: idOrganizacaoProjeto
            }

            const resposta = await novaSenha(payload)

            if (resposta.status === 200) {
                setProcessando(false)
                toast.success("Senha Atualizada com Sucesso.")
                setFormSenha(false)
                setFormToken(false)
                modalExibir("")
                navigate("/")
                return
            }

        } catch (error: any) {

            if (error.status === 400 || error.status === 401 || error.status === 402) {
                toast.error('Dados não confere. Tente Novamente!')
                setProcessando(false)
                return navigate('/')
            }

            return alert(error)

        }
    }

    useEffect(() => {

        const identificarProjeto = () => {

            const idOrganizacaoProjeto = idOrganizacaoProjetoSelecionada

            if (!idOrganizacaoProjeto) {
                return
            }

            return setIdOrganizacaoProjeto(idOrganizacaoProjeto)
        }

        identificarProjeto()

    }, [idOrganizacaoProjetoSelecionada])


    return (
        <>
            {modal.nome === 'ModalProjetosUsuarioRecuperarSenha' && <ModalProjetosUsuario dados={projetosUsuario} />}
            <div id='fundo_modal_recuperar_senha'>
                <div id="fundo_recuperar_senha">
                    <form id='form_nova_venda' onSubmit={idOrganizacaoProjeto === null ? buscarProjetosUser : proximoPasso}>
                        <div id="div_recuperar_senha">
                            <input
                                type='email'
                                required
                                onChange={(e) => setEmail(e.target.value.toLowerCase())} />
                            <span>Digite seu e-mail</span>
                        </div>

                        <div id="recuperar_senha_botao">
                            <div>
                                <Button type='button' cor='cancelar' isLoading={false} onClick={ocultarModal}>Cancelar</Button>
                            </div>
                            <div>
                                <Button type='submit' cor='enviar' isLoading={false}>Próximo</Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {formToken && <div id='fundo_modal_recuperar_senha'>
                <div id="fundo_recuperar_senha">
                    <form id='form_nova_venda' onSubmit={(e) => digitarSenha(e)}>
                        <div id="div_recuperar_senha">
                            <input
                                type='number'
                                required
                                onChange={(e) => setToken(e.target.value)} />
                            <span>Digite o token recebido por e-mail</span>
                        </div>

                        <div id="recuperar_senha_botao">
                            <div>
                                <Button type='button' cor='cancelar' isLoading={processando} onClick={ocultarModal}>Cancelar</Button>
                            </div>
                            <div>
                                <Button type='submit' cor='enviar' isLoading={processando}>
                                    {!processando && 'Próximo'}
                                    {processando && <Loader isLoading={processando} />}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>}

            {formSenha && <div id='fundo_modal_recuperar_senha'>
                <div id="fundo_recuperar_senha">
                    <form id='form_nova_venda' onSubmit={(e) => cadastrarNovaSenha(e)}>
                        <div id="div_recuperar_senha">
                            <input
                                type='password'
                                minLength={8}
                                maxLength={8}
                                required
                                onChange={(e) => setSenha(e.target.value)} />
                            <span>Digite a nova senha</span>
                        </div>

                        <div id="div_recuperar_senha">
                            <input
                                type='password'
                                minLength={8}
                                maxLength={8}
                                required
                                onChange={(e) => setConfirmarSenha(e.target.value)} />
                            <span>Confirmar senha</span>
                        </div>

                        <div id="recuperar_senha_botao">
                            <div>
                                <Button type='button' cor='cancelar' isLoading={processando} onClick={ocultarModal}>Cancelar</Button>
                            </div>
                            <div>
                                <Button type='submit' cor='enviar' isLoading={processando}>
                                    {!processando && 'Finalizar'}
                                    {processando && <Loader isLoading={processando} />}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>}
        </>
    )
}

export default ModalRecuperarSenha